export const SEMANTIC_COLORS = Object.freeze([
  'primary',
  'success',
  'info',
  'warning',
  'upgrade',
  'secondary',
  'muted',
]);

export const TYPE_COLORS = Object.freeze([
  'dark',
  'light',
  'darkMuted',
  'lightMuted',
  'link',
]);

export const SIZES = Object.freeze(['lg', 'md', 'sm']);

export const PROGRESS_BAR_COLORS = Object.freeze([
  'primary',
  'upgrade',
  'info',
  'success',
  'warning',
  'secondary',
]);
export const PROGRESS_CIRCLE_COLORS = PROGRESS_BAR_COLORS;
export const PROGRESS_CIRCLE_SIZES = Object.freeze([...SIZES, 'xs']);

export const COACHMARK_SIZES = Object.freeze(['md', 'sm']);

export const INPUT_COLORS = Object.freeze(['success', 'warning']);
export const NUMBER_PICKER_COLORS = Object.freeze(['success', 'warning']);

export const DATA_VIZ_THEMES = Object.freeze([
  'data-one',
  'data-two',
  'data-three',
  'data-four',
  'data-five',
  'data-six',
  'data-seven',
  'data-eight',
  'data-nine',
  'data-ten',
]);

export const KEYS = Object.freeze({
  DOWN: 'ArrowDown',
  END: 'End',
  ESC: 'Escape',
  HOME: 'Home',
  LEFT: 'ArrowLeft',
  PAGE_DOWN: 'PageDown',
  PAGE_UP: 'PageUp',
  RIGHT: 'ArrowRight',
  UP: 'ArrowUp',
  ENTER: 'Enter',
  SPACE: ' ',
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
});

// Deprecated. Moving to e.key
export const KEY_CODES = Object.freeze({
  DOWN: 40,
  END: 35,
  ESC: 27,
  HOME: 36,
  LEFT: 37,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  RIGHT: 39,
  UP: 38,
  ENTER: 13,
  SPACE: 32,
  BACKSPACE: 8,
  TAB: 9,
});

export const KEY_DIRECTIONS = Object.freeze({
  37: -1,
  38: -1,
  39: 1,
  40: 1,
});

export const PLACEMENTS = Object.freeze(['top', 'bottom', 'right', 'left']);

export const MARK_COLORS = Object.freeze([
  'primary',
  'secondary',
  'muted',
  'success',
  'warning',
  'upgrade',
  'info',
]);

export const LINK_COLORS = Object.freeze(['light', 'dark']);

export const TAB_COLORS = Object.freeze([
  'primary',
  'light',
  'dark',
  'transparent',
]);
export const TAB_ALIGN = Object.freeze(['left', 'right', 'even', 'center']);

export const MOTION_DISTANCES = Object.freeze(['normal', 'near', 'far']);

export const MOTION_DIRECTIONS = Object.freeze(['up', 'right', 'down', 'left']);

export const MOTION_SPEEDS = Object.freeze(['slow', 'normal', 'fast']);

export const FADE = Object.freeze({
  speed: {
    slow: 300,
    normal: 200,
    fast: 100,
  },
});

export const SLIDE = Object.freeze({
  speed: {
    slow: 450,
    normal: 350,
    fast: 250,
  },
  distance: {
    normal: 25,
    near: 5,
    far: 75,
  },
});
